import { useTranslation } from "react-i18next";
import { MdDragIndicator } from "react-icons/md";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { FulfillmentPriorityShop } from "../../../../../../@types/FulfillmentPriority";
import { getFulfillmentPriorityShopKey } from "../../../../../../shared/FulfillmentPriority";
import { ShopCard } from "../ShopCard";

import styles from "./SortableShopCard.module.css";

interface SortableShopCardProps {
  disabled: boolean;
  shop: FulfillmentPriorityShop;
  onStatusChange: (shop: FulfillmentPriorityShop) => void;
}

export function SortableShopCard({
  disabled,
  shop,
  onStatusChange,
}: SortableShopCardProps) {
  const { t } = useTranslation();
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: getFulfillmentPriorityShopKey(shop), disabled });

  return (
    <ShopCard
      ref={setNodeRef}
      shop={shop}
      disabled={disabled}
      isDragging={isDragging}
      style={{ transform: CSS.Transform.toString(transform), transition }}
      onStatusChange={onStatusChange}
      dragHandle={
        <button
          className={styles.dragHandle}
          type="button"
          aria-label={t("dragFulfillmentLocation", { name: shop.name })}
          disabled={disabled}
          {...attributes}
          {...listeners}
        >
          <MdDragIndicator aria-hidden="true" />
        </button>
      }
    />
  );
}
